import PropTypes from 'prop-types';
import { forwardRef } from 'react';
const MainLogo = forwardRef((props, ref) => {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      // xmlns:svgjs="http://svgjs.dev/svgjs"
      width={props.width || 120}
      height={props.height || 120}
      viewBox="0 0 2000 540"
      {...props}
    >
      <g transform="matrix(1,0,0,1,-1.2119569556914485,-1.251484874352684)">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 396 107"
          data-background-color="#ffffff"
          preserveAspectRatio="xMidYMid meet"
          height={540}
          width={2000}
          {...props}
        >
          <g
            id="tight-bounds"
            transform="matrix(1,0,0,1,0.23996747722691225,0.248015671154576)"
          >
            <svg
              viewBox="0 0 395.52 106.50380371046852"
              height={106.50380371046852}
              width={395.52}
              {...props}
            >
              <g>
                <svg
                  viewBox="0 0 395.52 106.50380371046852"
                  height={106.50380371046852}
                  width={395.52}
                  {...props}
                >
                  <g>
                    <svg
                      viewBox="0 0 486.4529842161224 130.98981883425753"
                      height={106.50380371046852}
                      width={395.52}
                      {...props}
                    >
                      <g transform="matrix(1,0,0,1,90.9329842161224,0)">
                        <svg
                          viewBox="0 0 395.52 130.98981883425753"
                          height={130.98981883425753}
                          width={395.52}
                          {...props}
                        >
                          <g id="textblocktransform">
                            <svg
                              viewBox="0 0 395.52 130.98981883425753"
                              height={130.98981883425753}
                              width={395.52}
                              id="textblock"
                              {...props}
                            >
                              <g>
                                <svg
                                  viewBox="0 0 395.52 130.98981883425753"
                                  height={130.98981883425753}
                                  width={395.52}
                                  {...props}
                                >
                                  <path
                                    d="M394.594 28.095C392.735 14.498 387.435 10.718 387.435 10.718 371.165-3.286 350.86-0.268 332.619 1.744 300.414 1.826 268.339 4.817 236.208 6.422 168.767 6.666 100.749 2.642 33.643 12.567 27.339 15.613-6.54 13.166 1.121 29.835 3.129 36.77 10.456 44.465 10.232 50.828 11.236 51.943 12.631 49.387 13.226 50.992 15.309 55.315 18.711 53.276 21.501 55.832 17.614 62.658 20.403 68.341 23.062 74.296 18.377 75.846 12.371 75.112 9.675 80.252 9.396 83.977 7.89 83.27 6.235 83.107 5.026 82.998 2.59 83.406 2.999 84.575 4.394 88.573-1.594 90.884 2.162 94.8-0.422 99.042 3.948 102.713 3.353 107.309 3.278 108.234 3.687 109.022 4.338 109.24 7.22 110.409 3.018 112.693 3.464 115.168 33.029 132.082 65.104 120.389 95.394 128.167 103.259 122.728 97.346 130.097 100.489 128.955 102.943 127.623 104.728 133.143 107.499 130.016 107.927 129.118 107.276 126.997 108.8 127.405 109.6 127.623 110.307 127.568 110.418 126.317 110.586 124.441 109.117 125.61 108.726 124.631 112.947 119.682 111.906 131.457 115.866 130.967 115.68 129.526 114.528 127.459 116.889 127.731 119.232 125.665 119.306 123.952 121.389 128.602 121.463 129.608 121.835 130.315 122.43 130.804 128.938 125.746 135.409 132.599 142.233 130.315 146.417 127.813 150.433 131.674 154.672 130.723 156.16 129.961 157.666 128.602 159.098 130.886 176.632 131.375 195.319 129.336 211.943 130.967 256.364 127.922 303.836 132.218 350.674 128.194 361.719 126.644 373.192 124.441 383.958 122.673 383.958 122.673 392.679 117.833 392.679 96.078S394.538 77.043 394.817 59.721C395.096 42.399 396.398 41.692 394.538 28.095Z"
                                    opacity={1}
                                    fill="var(--primary)"
                                    data-fill-palette-color="tertiary"
                                  />
                                  <g transform="matrix(1,0,0,1,55.76832,26.230666666666668)">
                                    <svg
                                      width={283.98335999999995}
                                      viewBox="4.13 -36.04 132.06 36.53"
                                      height={78.5284855009242}
                                      data-palette-color="#ffffff"
                                      {...props}
                                    >
                                      <path
                                        d="M24.22-20.26L24.22-16.43 8.81-16.43 8.81-3.83 26.71-3.83 26.71 0 4.13 0 4.13-35.55 26.46-35.55 26.46-31.69 8.81-31.69 8.81-20.26 24.22-20.26ZM52.88 0L48.14 0Q47.75-0.78 47.51-2.78L47.51-2.78Q44.36 0.49 39.99 0.49L39.99 0.49Q36.08 0.49 33.58-1.72 31.08-3.93 31.08-7.32L31.08-7.32Q31.08-11.45 34.21-13.73 37.35-16.02 43.04-16.02L43.04-16.02 47.43-16.02 47.43-18.09Q47.43-20.46 46.02-21.86 44.6-23.27 41.84-23.27L41.84-23.27Q39.43-23.27 37.79-22.05 36.15-20.83 36.15-19.09L36.15-19.09 31.61-19.09Q31.61-21.07 33.02-22.91 34.42-24.76 36.83-25.83 39.23-26.9 42.11-26.9L42.11-26.9Q46.68-26.9 49.27-24.62 51.85-22.34 51.95-18.33L51.95-18.33 51.95-6.18Q51.95-2.54 52.88-0.39L52.88-0.39 52.88 0ZM40.65-3.44L40.65-3.44Q42.77-3.44 44.68-4.54 46.58-5.64 47.43-7.4L47.43-7.4 47.43-12.82 43.89-12.82Q35.59-12.82 35.59-7.96L35.59-7.96Q35.59-5.83 37.01-4.64 38.43-3.44 40.65-3.44ZM74.41-7.01L74.41-7.01Q74.41-8.84 73.03-9.85 71.65-10.86 68.22-11.6 64.79-12.33 62.78-13.35 60.76-14.38 59.8-15.8 58.83-17.21 58.83-19.17L58.83-19.17Q58.83-22.41 61.58-24.66 64.33-26.9 68.6-26.9L68.6-26.9Q73.09-26.9 75.89-24.58 78.68-22.27 78.68-18.65L78.68-18.65 74.14-18.65Q74.14-20.51 72.57-21.85 70.99-23.19 68.6-23.19L68.6-23.19Q66.13-23.19 64.74-22.12 63.35-21.04 63.35-19.31L63.35-19.31Q63.35-17.68 64.64-16.85 65.94-16.02 69.32-15.26 72.7-14.5 74.8-13.45 76.9-12.4 77.91-10.93 78.93-9.45 78.93-7.32L78.93-7.32Q78.93-3.78 76.09-1.65 73.26 0.49 68.75 0.49L68.75 0.49Q65.57 0.49 63.13-0.63 60.69-1.76 59.31-3.77 57.93-5.79 57.93-8.13L57.93-8.13 62.45-8.13Q62.57-5.86 64.27-4.53 65.96-3.2 68.75-3.2L68.75-3.2Q71.31-3.2 72.86-4.24 74.41-5.27 74.41-7.01ZM89.71-26.42L89.71 0 85.2 0 85.2-26.42 89.71-26.42ZM84.83-33.42L84.83-33.42Q84.83-34.52 85.5-35.28 86.17-36.04 87.49-36.04 88.81-36.04 89.49-35.28 90.18-34.52 90.18-33.42 90.18-32.32 89.49-31.59 88.81-30.86 87.49-30.86 86.17-30.86 85.5-31.59 84.83-32.32 84.83-33.42ZM107.9 0.49L107.9 0.49Q102.53 0.49 99.16-3.04 95.79-6.57 95.79-12.48L95.79-12.48 95.79-13.31Q95.79-17.24 97.29-20.32 98.79-23.41 101.49-25.16 104.19-26.9 107.34-26.9L107.34-26.9Q112.49-26.9 115.35-23.51 118.2-20.12 118.2-13.79L118.2-13.79 118.2-11.91 100.31-11.91Q100.41-8.01 102.59-5.6 104.78-3.2 108.14-3.2L108.14-3.2Q110.54-3.2 112.2-4.17 113.86-5.15 115.1-6.76L115.1-6.76 117.86-4.61Q114.54 0.49 107.9 0.49ZM107.34-23.19L107.34-23.19Q104.6-23.19 102.75-21.2 100.89-19.21 100.45-15.63L100.45-15.63 113.69-15.63 113.69-15.97Q113.49-19.41 111.83-21.3 110.17-23.19 107.34-23.19ZM136.19-26.56L136.19-22.36Q135.17-22.53 133.97-22.53L133.97-22.53Q129.53-22.53 127.94-18.75L127.94-18.75 127.94 0 123.43 0 123.43-26.42 127.82-26.42 127.89-23.36Q130.11-26.9 134.19-26.9L134.19-26.9Q135.51-26.9 136.19-26.56L136.19-26.56Z"
                                        opacity={1}
                                        transform="matrix(1,0,0,1,0,0)"
                                        fill="#ffffff"
                                        className="wordmark-text-0"
                                        data-fill-palette-color="quaternary"
                                        id="text-0"
                                      />
                                    </svg>
                                  </g>
                                </svg>
                              </g>
                            </svg>
                          </g>
                        </svg>
                      </g>
                      <g transform="matrix(1,0,0,1,0,5.1522662074807855)">
                        <svg
                          viewBox="0 0 72.39429347300621 120.68528641929596"
                          height={120.68528641929596}
                          width={72.39429347300621}
                          {...props}
                        >
                          <g>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                              x={0}
                              y={0}
                              viewBox="30.827083519658654 18.03837341094086 38.3454022308225 63.92390379243734"
                              enableBackground="new 0 0 100 100"
                              xmlSpace="preserve"
                              height={120.68528641929596}
                              width={72.39429347300621}
                              className="icon-icon-0"
                              data-fill-palette-color="accent"
                              id="icon-0"
                              {...props}
                            >
                              <g fill="var(--primary)" data-fill-palette-color="accent">
                                <path
                                  d="M43.798 18.06c-0.251 0.057-0.502 0.254-0.586 0.509l-11.275 31.77c-0.167 0.481 0.251 1.076 0.754 1.076h8.4L30.877 80.892c-0.139 0.34 0.028 0.765 0.307 0.963 0.307 0.17 0.726 0.142 0.977-0.113l36.837-40.406c0.419-0.453 0.028-1.359-0.586-1.359H53.956l9.377-20.812c0.224-0.481-0.224-1.132-0.754-1.104H43.966C43.91 18.031 43.854 18.031 43.798 18.06L43.798 18.06zM44.496 19.645h16.856l-9.349 20.812c-0.195 0.481 0.195 1.104 0.726 1.104h13.87L33.584 77.777l9.377-26.9c0.167-0.481-0.251-1.048-0.753-1.075h-8.4L44.496 19.645 44.496 19.645z"
                                  fill="var(--primary)"
                                  data-fill-palette-color="accent"
                                />
                              </g>
                            </svg>
                          </g>
                        </svg>
                      </g>
                    </svg>
                  </g>
                </svg>
              </g>
              <defs />
            </svg>
            <rect
              width={395.52}
              height={106.50380371046852}
              fill="none"
              stroke="none"
              visibility="hidden"
            />
          </g>
        </svg>
      </g>
    </svg>
  )
});

export default MainLogo
MainLogo.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};